import { initializeDynamicLayout } from 'owa-layout';

export function initializeCalendarLayout() {
    document.body.style.minWidth = '580px';

    initializeDynamicLayout(false);
}
